















































import Vue from 'vue';
import _ from 'lodash';
import { Component, Prop } from 'vue-property-decorator';
import { Menu, MenuItem } from '../../types/menus';
import store from '../../store';

@Component
export default class MenuItemEditor extends Vue {
  @Prop() menuItem!: MenuItem;
  @Prop() menu!: Menu;

  get menuLabel(): string {
    return this.menuItem.label;
  }
  set menuLabel(value: string) {
    this.menuItem.label = value;
    this.updateMenuItem();
  }

  get menuURL(): string {
    return this.menuItem.url;
  }
  set menuURL(value: string) {
    this.menuItem.url = value;
    this.updateMenuItem();
  }

  get menuLoggedIn(): boolean {
    return this.menuItem.logged_in;
  }
  set menuLoggedIn(value: boolean) {
    this.menuItem.logged_in = value;
    this.updateMenuItem();
  }

  get menuLoggedOut(): boolean {
    return this.menuItem.logged_out;
  }
  set menuLoggedOut(value: boolean) {
    this.menuItem.logged_out = value;
    this.updateMenuItem();
  }

  updateMenuItem() {
    if (!_.isUndefined(this.menuItem.id)) {
      store.dispatch('menus/saveMenuItem', this.menuItem);
    }
  }

  saveNewMenuItem() {
    this.menuItem.menu_id = this.menu.id;
    this.menuItem.position = _.isUndefined(this.menu.items)
      ? 1
      : this.menu.items.length + 1;
    this.menuItem.logged_in = _.isUndefined(this.menuItem.logged_in)
      ? false
      : this.menuItem.logged_in;
    this.menuItem.logged_out = _.isUndefined(this.menuItem.logged_out)
      ? false
      : this.menuItem.logged_out;
    this.menuItem.parent_id = null;
    store.dispatch('menus/saveMenuItem', this.menuItem);
  }

  deleteItem() {
    store.dispatch('menus/deleteMenuItem', this.menuItem);
  }

  resetMenuItem() {
    this.menuLabel = '';
    this.menuItem.label = '';
    this.menuItem.url = '';
    this.menuItem.logged_in = false;
    this.menuItem.logged_out = false;
    this.menuItem.position = 0;
  }
}
